export const FileDependencyTypes = {
  CsvGeneratorService: Symbol.for('CsvGeneratorService'),
  ZipGeneratorService: Symbol.for('ZipGeneratorService'),
};
